import './header.css'

const Header = () => {
    return (
        <div className='header-container'>
            <p className='sub-title'>NBA RECORDS</p>
            <p className='main-title'>BEST GAMES IN HISTORY</p>
        </div>
    )
}

export default Header;